import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgLeaveLeftOutlined = (_a) => {
  var _b = _a, { size, title = "LeaveLeftOutlined" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 17l-5-5m0 0l5-5m-5 5h12m-3 5c0 .295 0 .443.011.57a3 3 0 002.404 2.687c.126.025.273.041.567.074l1.021.113c1.535.17 2.302.256 2.911.06a3 3 0 001.825-1.632c.261-.584.261-1.356.261-2.9V8.027c0-1.544 0-2.316-.261-2.9a3 3 0 00-1.825-1.633c-.61-.195-1.377-.11-2.91.06l-1.022.114c-.294.033-.441.049-.567.074a3 3 0 00-2.404 2.686C12 6.556 12 6.704 12 6.999"
  }));
};
var LeaveLeftOutlined = withIcon(SvgLeaveLeftOutlined);

export { LeaveLeftOutlined as default };
//# sourceMappingURL=LeaveLeftOutlined.es.js.map
